// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"00c2d7ce","977":"b34cb7c5"}[chunkId] + ".chunk.js";
};